// changePasswordModal.js
// A modal to change the password of an employee by an admin level user

import { useState } from "react";
import styles from "./changePasswordModal.module.css";

export const ChangePasswordModal = ({ onClose, onSubmit }) => {
  const [newPassword, setNewPassword] = useState("");
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2 className={styles.modalHeader}>Change Password</h2>

        <div className={styles.modalBody}>
          <p>Enter the new password for the employee</p>
          <input
            type="text"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <div className={styles.modalButtons}>
            <button
              onClick={() => onSubmit(newPassword)}
              disabled={!newPassword || newPassword.length < 8}
              className={styles.changePasswordButton}
            >
              Change Password
            </button>
            <button onClick={onClose} className={styles.cancelButton}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
